import { BaseError } from './baseError';
export class AuthError extends BaseError {
  constructor(e?: string) {
    super(e);
  }
}
